module.exports = __webpack_public_path__ + "img/Magnuss21.76f6ac69.jpg";